"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipZoneClient = void 0;
const core_auth_1 = require("@deliverr/core-auth");
const AbstractTransitTimeClient_1 = require("./AbstractTransitTimeClient");
const defaultConfig = {
    authEngine: core_auth_1.AuthEngine.BASIC,
    prefix: "/zip-zone",
    baseURL: process.env.TRANSIT_TIME_SERVICE_URL,
    basicAuthUser: process.env.TRANSIT_TIME_BASIC_AUTH_USER,
    basicAuthPassword: process.env.TRANSIT_TIME_BASIC_AUTH_PASSWORD,
};
class ZipZoneClient extends AbstractTransitTimeClient_1.AbstractTransitTimeClient {
    constructor(config = {}) {
        const clientConfig = Object.assign(Object.assign({}, defaultConfig), config);
        super(clientConfig);
    }
    async getShippingMethodZone(shippingMethod, fromZip, toZip) {
        const url = `${this.prefix}/v1/zone/${shippingMethod}/${toZip}/${fromZip}`;
        return this.getCached(url, {}, 3600000);
    }
    async getAllShippingMethodZones(shippingMethod) {
        const url = `${this.prefix}/v1/zone/${shippingMethod}`;
        return this.getCached(url, {}, 3600000);
    }
    async getFlexportStandardZones() {
        const url = `${this.prefix}/v1/zone/FLEXPORT.STANDARD`;
        return this.getCached(url, {}, 3600000);
    }
    async getShippingMethodZipZone(shippingMethod, destZip3) {
        const url = `${this.prefix}/v1/zone/${shippingMethod}/${destZip3}`;
        return this.get(url);
    }
    async updateCarrierZone(shippingMethod, zoneChart) {
        const url = `${this.prefix}/v1/zone/${shippingMethod}`;
        return this.put(url, zoneChart);
    }
    async getStateFromZip(zipcode) {
        return this.get(`${this.prefix}/v1/zip/${zipcode}`);
    }
    async getDistanceBetweenTwoZips(fromZip, toZip) {
        return this.get(`${this.prefix}/v1/zip/distance/${fromZip}/${toZip}`);
    }
}
exports.ZipZoneClient = ZipZoneClient;
//# sourceMappingURL=ZipZoneClient.js.map